module.exports = __webpack_public_path__ + "img/cab_1000.53d23c7c.jpg";